'use client';

import { Link } from '@packages/modules/src/Link/Link';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import {
  Accordion,
  AccordionDetails,
  AccordionItem,
  AccordionSummary,
} from '@packages/shared/src/ui/Accordion/Accordion';
import { type JSX } from 'react';
import { useIntl } from 'react-intl';
import { classes } from '../../../utils/classes';
import { messages } from '../PromotionBanner.messages';

export const PromotionAccordionTemplate = ({
  summaryContent,
  detailscontent,
  isExpanded,
  setIsExpanded,
  isPaybackPromotion,
  newsletterLink,
  onLinkClick,
}: {
  summaryContent: string;
  detailscontent: JSX.Element;
  isExpanded: boolean;
  setIsExpanded: (expanded: boolean) => void;
  isPaybackPromotion?: boolean;
  onLinkClick: () => void;
  newsletterLink: string;
}) => {
  const { formatMessage } = useIntl();
  const config = useConfig();

  return (
    <Accordion
      // INSPIRE-3604 - use transparent background to prevent sharp edges cover rounded
      // edges the uppermost wrapper defines the color
      type="single"
      value={isExpanded ? 'promotion-accordion' : ''}
      onValueChange={(newValue) => setIsExpanded(Boolean(newValue))}
      collapsible
      key="promotion-accordion"
    >
      <AccordionItem
        value="promotion-accordion"
        className="bg-color-transparent before:bg-color-transparent mb-0! shadow-none"
        key="promotion-accordion-item"
      >
        <AccordionSummary
          className={classes(
            config.styleVariant === 'dark' ? 'font-bold' : 'justify-center',
            isPaybackPromotion
              ? '[&>span]:bg-color-text-light'
              : '[&>span]:bg-color-primary-contrasttext',
          )}
          icon="icon-emp-arrow-medium-down"
          key="promotion-accordion-summary"
        >
          {summaryContent}
        </AccordionSummary>
        <AccordionDetails
          className={classes(
            isPaybackPromotion && '[&_button]:focus-visible:outline-color-text-light!',
          )}
        >
          {detailscontent}
          <div
            className={classes(
              'mt-3.5 flex items-center gap-2 border-t pt-2',
              isPaybackPromotion
                ? 'border-t-color-text-light'
                : 'border-t-color-primary-contrasttext',
              config.styleVariant === 'dark' ? 'flex-row' : 'flex-col',
            )}
          >
            <span className="icon-emp-mail h-4 w-4" />
            <Link
              className="text-size-body-sm hover:underline"
              href={newsletterLink}
              color="inherit"
              onClick={onLinkClick}
            >
              {formatMessage(messages.newsletterTeaserText)}
            </Link>
          </div>
        </AccordionDetails>
      </AccordionItem>
    </Accordion>
  );
};
